import { render, staticRenderFns } from "./PricingBackdrop.vue?vue&type=template&id=5e54a86e"
import script from "./PricingBackdrop.vue?vue&type=script&lang=js"
export * from "./PricingBackdrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports